export function removePixiObject(pixiObject) {
    var _pixiObject_parent;
    pixiObject === null || pixiObject === void 0 ? void 0 : (_pixiObject_parent = pixiObject.parent) === null || _pixiObject_parent === void 0 ? void 0 : _pixiObject_parent.removeChild(pixiObject);
}
export function bringToFront(container) {
    const parent = container.parent;
    if (parent === null) return;
    parent.removeChild(container);
    parent.addChild(container);
}
export function sendToBack(container) {
    const parent = container.parent;
    if (parent === null) return;
    parent.setChildIndex(container, 0);
}
export function isOverlapping(rect1, rect2) {
    return rect1.x < rect2.x + rect2.width && rect1.x + rect1.width > rect2.x && rect1.y < rect2.y + rect2.height && rect1.y + rect1.height > rect2.y;
}
export function isDescendantOf(child, parent) {
    if (child.parent == undefined) return false;
    if (child.parent == parent) return true;
    return isDescendantOf(child.parent, parent);
}
